import { Link } from 'react-router-dom';

import { homepage, posts } from '../content/site';

function LatestPosts() {
  if (posts.length === 0) {
    return (
      <div className="empty-state">
        <p>The blog is beginning. New essays, reflections, and reviews will appear here.</p>
      </div>
    );
  }

  return (
    <div className="post-list">
      {posts.slice(0, 3).map((post) => (
        <article className="post-row" key={post.slug}>
          <p className="post-row__label">{post.type}<br />{post.date}</p>
          <div>
            <Link className="post-row__title" to={`/blog/${post.slug}`}>{post.title}</Link>
            <p className="post-row__summary">{post.summary}</p>
          </div>
          <span className="post-row__meta">{post.readTime}</span>
        </article>
      ))}
    </div>
  );
}

export function HomePage() {
  return (
    <>
      <section className="home-hero">
        <img
          alt="Eli Schatz at the University of West Florida College of Business"
          className="home-hero__image"
          //src="/images/home/EliCollegeofBusiness.jpg"
          src="/images/home/uwf-tailgate.jpg"
          //src="/images/home/EliCOB.jpg"
        />
        <div className="home-hero__copy">
          {
            <p className="home-hero__label">Analyst · Writer · Leadership</p>
          }
          <h1>Eli Schatz .com</h1>
          {
            <p className="home-hero__subtitle">Bringing back a personal internet.</p>
          }
        </div>
      </section>

      <div className="site-container">
        <section className="home-intro">
          <p className="section-label">Pensacola, Florida </p>
          <h2>A personal home for a life in public.</h2>
          <p className="home-intro__copy">{homepage.intro}</p>
        </section>

        <section className="home-section">
          <div className="home-section__header">
            <h2>Latest from the blog</h2>
            <Link className="text-link" to="/blog">View the blog</Link>
          </div>
          <LatestPosts />
        </section>

        <section className="home-section home-split">
          <p className="section-label">Current work</p>
          <div className="experience-preview">
            <h2>Work, study, and public purpose.</h2>
            <p>{homepage.currentWork}</p>
            <Link className="text-link" to="/experience">View experience</Link>
          </div>
        </section>

        <section className="home-section home-split">
          <p className="section-label">A little more about me</p>
          <div className="about-preview">
            <h2>More than a résumé.</h2>
            <p>{homepage.about}</p>
            <Link className="text-link" to="/about">About Eli</Link>
          </div>
        </section>
      </div>
    </>
  );
}
